import React, { useEffect, useState } from 'react';
import Button from '../Button';
import ResourceDialog from './ResourceDialog';
import { FolderGlyph } from './Breadcrumb';
import { resourceMessage } from '../../domain/resources';
import s from './resources.module.css';

// "Move to": every destination the core offers (`folder_options`), Home first
// and each folder indented under its parent. A folder being moved is offered
// none of itself or what is inside it, so the refusal that would follow is
// never reachable from here; the provider asks again anyway, and a refusal from
// there (a folder deleted on another device meanwhile) is shown under the list.
export default function MoveDialog({ open, options, current = null, onMove, onClose }) {
  const [chosen, setChosen] = useState(current);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setChosen(current); setError(null); setSaving(false); }
  }, [open, current]);

  const move = async () => {
    setSaving(true);
    try {
      await onMove(chosen);
      onClose();
    } catch (err) {
      setError(err?.message || 'That could not be moved.');
      setSaving(false);
    }
  };

  return (
    <ResourceDialog
      open={open}
      title={resourceMessage('move_title')}
      onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <span className={s.spacer} />
          <Button onClick={move} loading={saving} disabled={chosen === current}>Move</Button>
        </>
      )}
    >
      <div className={s.options} role="listbox" aria-label={resourceMessage('move_title')}>
        {options.map((o) => (
          <button
            type="button"
            key={o.id || 'home'}
            role="option"
            aria-selected={o.id === chosen}
            className={[s.option, o.id === chosen ? s.optionChosen : ''].filter(Boolean).join(' ')}
            style={{ paddingLeft: 10 + o.depth * 18 }}
            onClick={() => setChosen(o.id)}
          >
            <FolderGlyph />
            {o.name}
          </button>
        ))}
      </div>
      {error ? <p className={s.error}>{error}</p> : null}
    </ResourceDialog>
  );
}
